import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLocation } from 'react-router-dom';
import { TopBar } from './TopBar';
import { Navigation } from './Navigation';
import { Footer } from './Footer';
export function Layout({
  children
}: {
  children: React.ReactNode;
}) {
  const location = useLocation();
  return <div className="min-h-screen flex flex-col" data-id="element-88">
      <TopBar data-id="element-89" />
      <Navigation data-id="element-90" />
      <AnimatePresence mode="wait" data-id="element-91">
        <motion.main key={location.pathname} initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -10
      }} transition={{
        duration: 0.4,
        ease: [0.22, 1, 0.36, 1]
      }} className="flex-grow" data-id="element-92">
          {children}
        </motion.main>
      </AnimatePresence>
      <Footer data-id="element-93" />
    </div>;
}